import { z } from "zod";

export const strongbackTypeOptions = [
  { value: "none", label: "None" },
  { value: "Loosering", label: "Loosering" },
  { value: "Gripper", label: "Gripper" },
  { value: "Bar", label: "Bar" },
];

export const flangeRatingOptions = [
  { title: "150#", value: "150" },
  { title: "300#", value: "300" },
  { title: "600#", value: "600" },
  { title: "900#", value: "900" },
  { title: "1500#", value: "1500" },
  { title: "2500#", value: "2500" },
];

const strongbackSchema = z.object({
  type: z.string().optional(),
  distance: z.number().optional(),
  unit_for_distance: z.string().optional(),
  flange_nps: z.string().optional(),
  flange_rating: z.string().optional(),
  custom_diameter: z.number().optional(),
  raised_face_od: z.number().optional(),
  flange_num_bolt_holes: z.number().optional(),
  flange_stud_size: z.number().optional(),
  flange_bolt_circle: z.number().optional(),
});

export const baseSchema = z.object({
  // For Tee flow
  strongback_header: z.boolean().optional(),
  strongback_riser: z.boolean().optional(),
  // For 90 (long radius) flow
  strongback_top: z.boolean().optional(),
  strongback_bottom: z.boolean().optional(),
  match_strongback_to_enclosure: z.boolean().optional(),

  strongbacks: z.array(strongbackSchema),
});

export type StrongbackTypeLocationSchema = z.infer<typeof baseSchema>;
